export const get = (o: unknown, key: string): unknown => {
  if (typeof key !== 'string') {
    return
  }

  let val: unknown = o
  for (const nextKey of key.split('.')) {
    val = (val as Record<string, unknown> | null | undefined)?.[nextKey]
  }

  return val
}

export default get
